<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options"
                 text-field="text" value-field="value">
  </b-form-select>
</template>

<script>
  export default {
    name: 'dataset-select',
    props: ['value'],
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      options () {
        const options = this.$store.getters.datasets().map(ds => {
          return {
            text: ds.name || ds.datasetId,
            value: ds.datasetId
          }
        })
        return [{text: '', value: null}].concat(options)
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/dataset-select.vue